export enum RedirectSourceEnum {
  PORTFOLIO = 'portfolio',
  WORKSPACE_DASHBOARD = 'workspace_dashboard',
}
